import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import Selectors from 'feedback-public-submission-ui/constants/Selectors';
// @ts-expect-error types missing
import getBestContrastColor from 'feedback-utils/bestContrastColor';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SubmitButton = ({
  surveyConfig,
  feedbackResponse,
  handleClickSubmit
}) => {
  const submitText = surveyConfig.strings.commonStrings.submit;
  const isLoading = feedbackResponse.isSubmittingFollowUp;
  const themeColor = surveyConfig.themeColor;
  const contrastColor = getBestContrastColor(themeColor);
  return /*#__PURE__*/_jsxs("button", {
    type: "submit",
    id: "submit-button",
    "data-selenium-test": Selectors.SUBMIT_BUTTON,
    onClick: handleClickSubmit,
    style: {
      backgroundColor: themeColor,
      borderColor: themeColor,
      color: contrastColor
    },
    disabled: isLoading,
    children: [/*#__PURE__*/_jsx("span", {
      style: {
        opacity: isLoading ? '0' : '1'
      },
      children: submitText
    }), /*#__PURE__*/_jsx("span", {
      className: "loading-spinner-container",
      style: {
        opacity: isLoading ? '1' : '0'
      },
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        use: "primary-white",
        size: "extra-small",
        margin: "0"
      })
    })]
  });
};
export default SubmitButton;